import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Thumbs } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/thumbs';

import '../assets/css/style2.css';
import '../assets/css/lineicons.css';
import '../assets/css/datepicker.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/swiper2.min.css';
import '../assets/css/bootstrap.min.css';

// Image imports
import gallery1 from '../assets/images/rooms/twinroom/gallery1.webp';
import gallery2 from '../assets/images/rooms/twinroom/gallery2.webp';
import gallery3 from '../assets/images/rooms/twinroom/gallery3.webp';
import gallery4 from '../assets/images/rooms/twinroom/gallery4.webp';
import gallery5 from '../assets/images/rooms/twinroom/gallery5.webp';
import thumb1 from '../assets/images/rooms/twinroom/thumb/gallery1.jpg';
import thumb2 from '../assets/images/rooms/twinroom/thumb/gallery2.jpg';
import thumb3 from '../assets/images/rooms/twinroom/thumb/gallery3.jpg';
import thumb4 from '../assets/images/rooms/twinroom/thumb/gallery4.jpg';
import thumb5 from '../assets/images/rooms/twinroom/thumb/gallery5.jpg';
import icon09 from '../assets/images/rooms/w_icons/icon09.png';
import icon03 from '../assets/images/rooms/w_icons/icon03.png';
import icon04 from '../assets/images/rooms/w_icons/icon04.png';
import icon07 from '../assets/images/rooms/w_icons/icon07.png';
import icon10 from '../assets/images/rooms/w_icons/icon10.png';
import icon11 from '../assets/images/rooms/w_icons/icon11.png';
import headerBackground from '../assets/images/rooms/header2.webp';
import swipeIcon from '../assets/images/rooms/swipe.png';

const Twin = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const galleryImages = [gallery1, gallery2, gallery3, gallery4, gallery5];
  const thumbImages = [thumb1, thumb2, thumb3, thumb4, thumb5];

  useEffect(() => {
    if (window.jQuery && window.jQuery.fancybox) {
      window.jQuery('[data-fancybox]').fancybox({
        // options
      });
    }
  }, []);

  return (
    <div className="example">
      <div className="cursor js-cursor"></div>

      <Navbar />

      <main id="main">
        <header className="page-header" style={{ backgroundImage: `url(${headerBackground})` }}>
          <div className="container">
            <h1>DELUXE TWIN ROOM</h1>
            <p>Immersion into Well-being</p>
          </div>
          <div className="scroll-down"></div>
        </header>

        <section className="content-section kentbg" style={{ padding: '50px 0 0' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="room-gallery-top">
                  <Swiper
                    modules={[FreeMode, Thumbs]}
                    spaceBetween={10}
                    slidesPerView={'auto'}
                    freeMode={true}
                    thumbs={{ swiper: thumbsSwiper }}
                    className="mySwiper2"
                    style={{
                      padding: '10px 0',
                      overflow: 'hidden',
                    }}
                  >
                    {galleryImages.map((gallery, index) => (
                      <SwiperSlide 
                        key={`gallery-${index}`} 
                        style={{
                          width: 'auto',
                          height: '400px',
                          display: 'inline-block',
                        }}
                      >
                        <a href={gallery} data-fancybox>
                          <img 
                            src={gallery} 
                            alt={`Gallery item ${index + 1}`} 
                            style={{
                              height: '400px',
                              width: 'auto',
                              objectFit: 'cover',
                              borderRadius: '5px',
                            }} 
                          />
                        </a>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="room-gallery-thumbs desktopview">
                  <Swiper
                    modules={[FreeMode, Thumbs]}
                    spaceBetween={10}
                    slidesPerView={5}
                    watchSlidesProgress={true}
                    onSwiper={setThumbsSwiper}
                    className="mySwiper"
                    breakpoints={{
                      1024: { slidesPerView: 5 },
                      768: { slidesPerView: 3 },
                      640: { slidesPerView: 2 },
                      320: { slidesPerView: 1 }
                    }}
                  >
                    {thumbImages.map((thumb, index) => (
                      <SwiperSlide key={`thumb-${index}`}>
                        <img className="height-control-lighter" src={thumb} alt={`Thumbnail ${index + 1}`} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
              <div className="col-12 mobileview" style={{ marginTop: '-35px', paddingBottom: '10px' }}>
                <img src={swipeIcon} alt="Swipe" />
              </div>
              <div className="col-lg-9 whitetext spacing30">
                <h3 style={{ fontFamily: 'Argesta Display' }}>
                  The twin room shines as the cutest room in the house, encompassing the authentic atmosphere of an English cottage. Washed in a minty green, it is ideal for travel buddies from all around.
                </h3>
              </div>
              <div className="col-lg-3 col-12 whitetext">
                <a href="https://live.ipms247.com/booking/book-rooms-kentcottagenuwaraeliya" className="custom-button-cream roombtn">
                  CHECK AVAILABILITY
                </a>
              </div>
              <div className="col-12">
                <div className="room-info-box whitetext">
                  <h6 className="whitetext">Room size 35 m²</h6>
                  <p>
                    Featuring free toiletries and bathrobes, this twin room includes a private bathroom with a bath, a shower and a bidet. The spacious twin room features a private entrance, a tea and coffee maker, a wardrobe, a tiled floor, as well as a flat-screen TV with cable channels. The unit has 2 beds.
                  </p>
                </div>
                <div className="room-info-box">
                  <h6 className="whitetext">Facilities</h6>
                  <ul className="whitetext">
                    <li>
                      <figure><img src={icon09} alt="gallery" /></figure><b>Room Type</b><span>2 Single beds non-smoking room</span>
                    </li>
                    <li>
                      <figure><img src={icon03} alt="gallery" /></figure><b>In-House Dining</b><span>Our fusion cuisine will cater to your dining needs</span>
                    </li>
                    <li>
                      <figure><img src={icon04} alt="gallery" /></figure><b>Wifi</b><span>Wi-Fi available</span>
                    </li>
                    <li>
                      <figure><img src={icon07} alt="gallery" /></figure><b>In room entertainment</b><span>TV</span>
                    </li>
                    <li>
                      <figure><img src={icon10} alt="gallery" /></figure><b>Other facilities</b><span>Heater</span>
                    </li>
                    <li>
                      <figure><img src={icon11} alt="gallery" /></figure><b>Scenic Hill View</b><span>Enjoy waking up to the misty tea mountains of Nuwara Eliya</span>
                    </li>
                  </ul>
                </div>
                <div className="room-info-box whitetext">
                  <h6 className="whitetext">Useful Information</h6>
                  <ul>
                    <li><b>Check-in </b><span>From 14:00 to 00:00</span></li>
                    <li><b>Check-out </b><span>Available 24 hours</span></li>
                    <li><b>Pets</b><span>Pets are not allowed</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <style>
        {`
          .page-header {
            position: relative;
            height: 60vh;
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: left;
            color: white;
          }

          .page-header .container {
            padding: 20px;
            max-width: 1200px;
            margin: 0 auto;
          }

          .page-header .container h1 {
            width: 100%;
            display: block;
            font-size: 48px;
            font-weight: 300;
            margin-bottom: 10px;
            line-height: 1.2;
            font-family: "Argesta Display";
            text-indent: 130px;
          }

          .page-header .container p {
            font-size: 22px;
            font-weight: 300;
            margin: 0;
            line-height: 1.5;
            text-indent: 130px;
          }

          .scroll-down {
            position: absolute;
            bottom: 20px;
            width: 2px;
            height: 40px;
            background: white;
            margin: 0 auto;
            left: 50%;
            transform: translateX(-50%);
          }

          @media (max-width: 768px) {
            .page-header {
              height: 60vh;
              background-size: cover !important;
              background-position: center;
            }

            .page-header .container h1 {
              font-size: 20px;
              line-height: 1.2;
              text-indent: 50px;
            }

            .page-header .container p {
              font-size: 0.9rem;
              line-height: 1.5;
              text-indent: 50px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Twin;